/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const isEmptyString = (value) => value === "";

export { isEmptyString };
//# sourceMappingURL=isEmptyString.js.map
